import { YEventHandlers, $trigger } from './events';

export class YTimer {
    $handlers: YEventHandlers<{ fired: void }>

    private _period: number;
    private _id?: number;
    private _firing: boolean;

    //period in seconds
    constructor(period: number, start?: boolean) {
        this._period = period;
        this._firing = false;

        if(start)
            this.start();
    }

    start() {
        if(this._id != null) return;

        if(this._firing) {
            this._id = -1;
            return;
        }

        const handler = () => {
            this._firing = true;
            $trigger(this, 'fired');
            this._firing = false;
            if(this._id != null)
                this._id = setTimeout(handler, this._period * 1000);
        }

        this._id = setTimeout(handler, this._period * 1000);
    }

    stop() {
        if(this._id == null) return;
        if(!this._firing)
            clearTimeout(this._id);
        this._id = undefined;
    }
}
